// Entrypoint for the PUBLIC pages (marketing layout opt-in via
// javascript_include_tag "public"). Deliberately slim: MapLibre + the Vega
// runtime and the mount modules — no Turbo, no Stimulus, and never the app
// bundle. Everything initializes lazily on visibility so first paint is pure
// HTML/CSS.
import { initTrendsMaps } from "./public/trends_map"
import { initTrendsScatters } from "./public/trends_scatter"
import { initTrendsLeaderMaps } from "./public/trends_leader_map"
import { initTrendsHeros } from "./public/trends_hero"
import { initIndustryHeros } from "./public/industry_hero"
import { initLanding } from "./public/landing"
import { initCentreBenchmarks } from "./public/centre_benchmark"
import { initCentreMaps } from "./public/centre_maps"
import { initVegaLiteCharts } from "./public/vega_lite_charts"

function init() {
  initTrendsHeros()
  initIndustryHeros()
  initLanding()
  initTrendsMaps()
  initTrendsScatters()
  initTrendsLeaderMaps()
  initCentreBenchmarks()
  initCentreMaps()
  initVegaLiteCharts()
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", init)
} else {
  init()
}
